/* tslint:disable */
import {LoadCMSAction} from '../../app/shared/actions/cms';

export const localEn = {
  "LANG_DE": "German",
  "LANG_EN": "English",
  "LANG_ES": "Spanish",
  "LANG_FR": "French",
  "LANG_IT": "Italian",
  "LANG_NL": "Dutch",
  "MONDAY": "Monday",
  "TUESDAY": "Tuesday",
  "WEDNESDAY": "Wednesday",
  "THURSDAY": "Thursday",
  "FRIDAY": "Friday",
  "SATURDAY": "Saturday",
  "SUNDAY": "Sunday",
  "IMPERSONATE_USER": "Impersonate user",
  "LEAVE_IMPERSONATION": "Leave impersonation",
  "LOGOUT": "Log Out",
  "RUN_AS": "as",
  "CLOSE": "Close",
  "LIMITED": "Limited",
  "SHOW_X_ELEMENTS_START": "Display",
  "SHOW_X_ELEMENTS_END": "elements",
  "SEARCH": "Search",
  "NAME": "Name",
  "EMAIL": "Email",
  "IMPERSONATE": "Impersonate",
  "CANCEL": "Cancel",
  "SEND": "Send",
  "DOWNLOAD": "Download",
  "SUBMIT": "Submit",
  "SUBMIT_RENEW": "Submit & add new",
  "SUBMIT_DUPLICATE": "Submit & duplicate",
  "PAGINATION_INFO": "Showing {{from}} to {{to}} of {{filteredLength}} elements",
  "PAGE_SIZE_ALL": "All",
  "FILTERED_PAGINATION_INFO": "Showing {{from}} to {{to}} of {{filteredLength}} elements (filtered from {{totalLength}} elements)",
  "CLIENT_SELECTOR_PLACEHOLDER": "Change Client...",
  "SITE_NOT_WELL_FILLED": "Site not well filled",
  "INVALID": "Invalid",
  "CONFIRMATION": "Confirmation",
  "UNSAVED_CHANGES": "You have unsaved changes. Are you sure you want to leave this page ?",
  "EXPANDER_TITLE": "Expand/Collapse",
  "All": "All",
  "DELETE": "Remove",
  "DELETE_DELETE": "Delete",
  "SAVE_CHANGES": "Save Change",
  "SAVING_CHANGES": "Saving Changes...",
  "PRINT": "Print",
  "OFFICE_NONE": " ",
  "OFFICE_BE": "Belgium",
  "OFFICE_FR": "France",
  "OFFICE_ES": "Spain",
  "OFFICE_DE": "Germany",
  "OFFICE_CN": "China",
  "OFFICE_IT": "MCube Italia",
  "OFFICE_NL": "Netherlands",
  "OFFICE_UK": "United Kingdom",
  "OFFICE_HK": "Hongkong",
  "YES": "Yes",
  "NO": "No",
  "BACK": "Back",
  "IMPERSONATE_DIALOG": "Impersonate user list dialog",
  "IMPERSONATE_DIALOG_TITLE": "Impersonate user",
  "IMPERSONATE_DIALOG_EXPLAIN_P1": "With this option you can browse the Back office as you were connected with another user. This option is only available for administrators.",
  "IMPERSONATE_DIALOG_EXPLAIN_P2": "Any action performed under \"impersonation\" will be done with your identity. The \"impersonation\" is just a simulation of what other users can see.",
  "ROLES_GROUP": "Roles group",
  "DATETIME_PICKER_TODAY": "Go to today",
  "DATETIME_PICKER_CLEAR": "Clear selection",
  "DATETIME_PICKER_CLOSE": "Close the picker",
  "DATETIME_PICKER_SELECT_MONTH": "Select Month",
  "DATETIME_PICKER_PREV_MONTH": "Previous Month",
  "DATETIME_PICKER_NEXT_MONTH": "Next Month",
  "DATETIME_PICKER_SELECT_YEAR": "Select Year",
  "DATETIME_PICKER_PREV_YEAR": "Previous Year",
  "DATETIME_PICKER_NEXT_YEAR": "Next Year",
  "DATETIME_PICKER_SELECT_DECADE": "Select Decade",
  "DATETIME_PICKER_PREV_DECADE": "Previous Decade",
  "DATETIME_PICKER_NEXT_DECADE": "Next Decade",
  "DATETIME_PICKER_PREV_CENTURY": "Previous Century",
  "DATETIME_PICKER_NEXT_CENTURY": "Next Century",
  "DATETIME_PICKER_INCREMENT_HOUR": "Increment Hour",
  "DATETIME_PICKER_PICK_HOUR": "Pick Hour",
  "DATETIME_PICKER_DECREMENT_HOUR": "Decrement Hour",
  "DATETIME_PICKER_INCREMENT_MINUTE": "Increment Minute",
  "DATETIME_PICKER_PICK_MINUTE": "Pick Minute",
  "DATETIME_PICKER_DECREMENT_MINUTE": "Decrement Minute",
  "DATETIME_PICKER_INCREMENT_SECOND": "Increment Second",
  "DATETIME_PICKER_PICK_SECOND": "Pick Second",
  "DATETIME_PICKER_DECREMENT_SECOND": "Decrement Second",
  "TOAST_ERROR_TITLE": "Error",
  "TOAST_SUCCESS_TITLE": "Success",
  "TOAST_INFO_TITLE": "Information",
  "TOAST_WARNING_TITLE": "Warning",
  "TOAST_ACCESS_DENIED_TITLE": "Access Denied",
  "SITE_TITLE": "Back Office",
  "ERROR_PAGE_NOT_FOUND": "404",
  "ERROR_PAGE_NOT_FOUND_TITLE": "Houston, we have a problem.",
  "ERROR_PAGE_NOT_FOUND_PARA": "Actually, the page you are looking for does not exist.",
  "ERROR_PAGE_RETURN_HOME": "Return home",
  "ERROR_PAGE_ACCESS_DENIED": "403",
  "ERROR_PAGE_ACCESS_DENIED_TITLE": "Houston, you have a problem.",
  "ERROR_PAGE_ACCESS_DENIED_PARA": "Actually, you do not have access to the page.",
  "EXTERNAL_APPS": "More Apps",
  "PRIVACY_POLICY": "Privacy Policy",
  "TERMS_OF_USE": "Terms Of Use",
  "BREAD_CRUMB_CLIENTS": "Clients",
  "BREAD_CRUMB_ORDERS": "Orders",
  "BREAD_CRUMB_REPORTS": "Reports",
  "BREAD_CRUMB_SITES": "Sites",
  "BREAD_CRUMB_SUBSCRIPTIONS": "Subscriptions",
  "SELECT_PLACE_TO_PRINT": "Select a place to print",
  "ORDERS_LIST_FILTER_DELIVERY_DATE": "Delivery date",
  "GENERIC_DELIVERY_DATE": "Delivery date",
  "GENERIC_DELIVERY2": "Delivery",
  "ORDERS_LIST_FILTER_PICKUP_DATE": "Pickup date",
  "ORDERS_LIST_FILTER_DISPATCH_DATE": "Dispatch date",
  "ORDERS_LIST_FILTER": "Orders list filter",
  "ORDERS_LIST_CLIENT_NAME": "Client",
  "ORDERS_LIST_SITE_NAME": "Site",
  "ORDERS_LIST_SUBSCRIPTION_NAME": "Subscription",
  "ORDERS_LIST_EXPEDITION_DATE": "Dispatch",
  "ORDERS_LIST_PICKUP_DATE": "Pickup",
  "ORDERS_LIST_DELIVERY_DATE": "Delivery",
  "ORDERS_LIST_STATUS": "Status",
  "ORDERS_LIST_FILTER_PROGRESS": "Progress",
  "ORDERS_LIST_FILTER_BANC": "Banc",
  "ORDERS_LIST_FILTER_CONFIG": "Config",
  "ORDERS_LIST_CLIENT_NAME_DETAILS": "Client name",
  "ORDERS_LIST_SUBSCRIPTION_TYPE": "Type",
  "ORDERS_LIST_SUBSCRIPTION_STATUS": "Status",
  "ORDERS_LIST_SUBSCRIPTION_PLAYERS": "Player",
  "ORDERS_LIST_SUBSCRIPTION_PROGRAM": "Program",
  "ORDERS_LIST_SHIPPING_TYPE": "Type",
  "ORDERS_LIST_SHIPPING_CARRIER": "Carrier",
  "ORDERS_LIST_SHIPPING_TRACKING": "Tracking",
  "ORDERS_LIST_SHIPPING_PICKUP_DATE": "Pickup",
  "ORDERS_LIST_SHIPPING_DELIVERY_DATE": "delivery",
  "ORDERS_LIST_SHIPPING_DELIVERY_STATUS": "Delivery status",
  "ORDERS_LIST_SHIPPING_STATUS": "Status",
  "ORDERS_LIST_CITY": "City",
  "ORDERS_LIST_ZIP": "Zip",
  "ORDER_FORM_TITLE_SITE": "Site",
  "ORDER_FORM_SITE_NAME": "Name",
  "ORDER_FORM_SITE_NAME_SUFFIX": "Suffix",
  "ORDER_FORM_SITE_EXTERNAL_ID": "ExtID",
  "ORDER_FORM_SITE_TIMEZONE": "Time zone",
  "ORDER_FORM_SITE_CULTURES": "Culture",
  "ORDER_FORM_SITE_CONCEPTS": "Concepts",
  "ORDER_FORM_STATUTORY_NAME": "Statutory name",
  "ORDER_FORM_TITLE_ADDRESS": "Site address",
  "ORDER_FORM_TITLE_ADDRESS_SIMPLE": "Address",
  "ORDER_FORM_TITLE_ADDRESS_DELIVERY": "Shipping address",
  "ORDER_FORM_TITLE_OTHERS": "Others",
  "ORDER_FORM_ADDRESS_LINE_1": "Line 1",
  "ORDER_FORM_ADDRESS_LINE_2": "Line 2",
  "ORDER_FORM_ADDRESS_LINE_3": "Line 3",
  "ORDER_FORM_ADDRESS_COUNTRY": "Country",
  "ORDER_FORM_ADDRESS_ZIP": "Zip",
  "ORDER_FORM_ADDRESS_CITY": "City",
  "ORDER_FORM_ADDRESS_STATE": "State",
  "ORDER_FORM_TITLE_CONTACT": "Contact",
  "ORDER_FORM_CONTACT_NAME": "Last name",
  "ORDER_FORM_CONTACT_SURNAME": "First name",
  "ORDER_FORM_CONTACT_NAME_PLACEHOLDER": "Example: Smith",
  "ORDER_FORM_CONTACT_SURNAME_PLACEHOLDER": "Example: John",
  "ORDER_FORM_CONTACT_PHONE": "Phone",
  "ORDER_FORM_CONTACT_MOBILE": "Mobile",
  "ORDER_FORM_CONTACT_DEPARTMENT": "Job title",
  "ORDER_FORM_CONTACT_EMAIL": "Email",
  "ORDER_FORM_TITLE_SUBSCRIPTION": "Subscription",
  "ORDER_FORM_SUBSCRIPTION_NAME": "Name",
  "ORDER_FORM_SUBSCRIPTION_PRODUCT": "Product",
  "ORDER_FORM_SUBSCRIPTION_SERVICE": "Service",
  "ORDER_FORM_SUBSCRIPTION_STATUS": "Status",
  "ORDER_FORM_SUBSCRIPTION_SCREEN_ORIENTATION": "Orientation",
  "ORDER_FORM_TITLE_SUB_NET_IP": "Network",
  "ORDER_FORM_NETWORK_IP_ADDRESS_IS_DHCP": "DHCP",
  "ORDER_FORM_NETWORK_IP_ADDRESS_IP": "Ip",
  "ORDER_FORM_NETWORK_IP_ADDRESS_MASK": "Subnet",
  "ORDER_FORM_NETWORK_IP_ADDRESS_GATEWAY": "Gateway",
  "ORDER_FORM_NETWORK_IP_ADDRESS_DNS1": "DNS1",
  "ORDER_FORM_NETWORK_IP_ADDRESS_DNS2": "DNS2",
  "ORDER_FORM_TITLE_SUB_NET_PROXY": "Proxy",
  "ORDER_FORM_TITLE_SUB_NET_WIFI": "Wifi",
  "ORDER_FORM_NETWORK_PROXY_ADDRESS": "Proxy",
  "ORDER_FORM_NETWORK_PROXY_PORT": "Port",
  "ORDER_FORM_TITLE_MISCELLANEOUS": "Order",
  "ORDER_FORM_SITE_EXPEDITION_DATE": "Dispatch",
  "ORDER_FORM_URL": "Url",
  "ORDER_FORM_WIFI_SSID": "Network SSID",
  "ORDER_FORM_WIFI_security": "Security",
  "ORDER_FORM_WIFI_PASSWORD": "Password",
  "ORDER_FORM_WIFI_EAP_METHOD": "EAP Method",
  "ORDER_FORM_WIFI_EAP_PHASE_2_AUTH": "Phase 2 auth",
  "ORDER_FORM_WIFI_EAP_CA_USER": "User Certificate",
  "ORDER_FORM_WIFI_EAP_IDENTITY": "Identity",
  "ORDER_FORM_WIFI_EAP_ANONYMOUS_IDENTITY": "Anonymous Id",
  "ORDER_FORM_WIFI_EAP_CA_CERTIFICATE": "CA Certificate",
  "ORDER_FORM_WIFI_SECURITY_NONE": "None",
  "ORDER_FORM_WIFI_SECURITY_WEP": "WEP",
  "ORDER_FORM_WIFI_SECURITY_WPA2": "WPA2 PSK",
  "ORDER_FORM_WIFI_SECURITY_WPA2AES": "WPA2 AES",
  "ORDER_FORM_WIFI_SECURITY_802EAP": "802.1x EAP",
  "ORDER_FORM_WIFI_EAP_METHOD_PEAP": "PEAP",
  "ORDER_FORM_WIFI_EAP_METHOD_TLS": "TLS",
  "ORDER_FORM_WIFI_EAP_METHOD_TTLS": "TTLS",
  "ORDER_FORM_WIFI_EAP_METHOD_PWD": "PWD",
  "ORDER_FORM_WIFI_PHASE_2_AUTH_NONE": "None",
  "ORDER_FORM_WIFI_PHASE_2_AUTH_PAP": "PAP",
  "ORDER_FORM_WIFI_PHASE_2_AUTH_MSCHAP": "MSCHAP",
  "ORDER_FORM_WIFI_PHASE_2_AUTH_MSCHAPV2": "MSCHAPV2",
  "ORDER_FORM_WIFI_PHASE_2_AUTH_GTC": "GTC",
  "ORDER_FORM_WIFI_ENABLE": "Enabled",
  "ORDER_CANCEL": "Cancel order",
  "CONFIRM_CANCEL_ORDER": "Do you really want to cancel this order ?",
  "CONFIRM_RESET_ORDER": "Do you really want to reset this order ?",
  "CONFIRM_CLOSE_ORDER": "Do you really want to close this order ?",
  "MESSAGE_RESET_ORDER": "This action will be reset order at 'Has player' and keep the player linked.",
  "MESSAGE_CLOSE_ORDER": "This action will close the order and you will not able to setup your player.",
  "ORDER_CANCEL_SUCCESS": "Order cancel success",
  "ORDER_RESET_SUCCESS": "Order reset success",
  "ORDER_CANCEL_ERROR": "Order cancel error",
  "COMPANY_DELETE_ERROR": "Company delete error",
  "COMPANY_DELETE_SUCCESS": "Company delete success",
  "ORDER_RESET_ERROR": "Order reset error",
  "CANCEL_ORDER": "Cancel order",
  "HAS_MATERIAL": "Has material",
  "HAS_SETUP": "Has installation",
  "IS_SOLD": "Player sold",
  "ORDERS_ADD_PAGE_TITLE": "Order creation",
  "ORDERS_EDIT_PAGE_TITLE": "Order edit",
  "ORDERS_BREAD_CRUMB_ADD_TITLE": "Order creation",
  "ORDERS_BREAD_CRUMB_EDIT_TITLE": "Order edit",
  "ORDERS_NEW_TITLE": "New Order",
  "ORDERS_DOWNLOAD_TEMPLATE": "Import Template",
  "ORDERS_EXCHANGE_TITLE": "Exchange",
  "ORDERS_DEPLOY_TITLE": "Deploy",
  "ORDER_LIST_PRINT_LABEL_IP": "Print label IP",
  "ORDER_LIST_PRINT_LABEL_ADDRESS": "Print label address",
  "ORDER_LIST_ASSIGN_PLAYER": "Assign player",
  "ORDER_LIST_ADD_TRACKING_NUMBER_TITLE": "A tracking number to order",
  "ORDER_LIST_ADD_TRACKING_NUMBER": "Tracking number",
  "ORDER_LIST_ADD_TRACKING_NUMBER_PLACEHOLDER": "Enter you tracking number",
  "ORDER_LIST_ADD_PLAYER": "Assign player",
  "ORDER_LIST_PICK_UP_TRANSPORTER": "Pickup Transporter",
  "ORDER_LIST_TYPE": "Type",
  "ORDER_LIST_MANUALLY_CLOSE_ORDER": "Manually close order",
  "ORDER_LIST_MANUALLY_DELIVERY_DATE": "Set manually delivery date",
  "ORDER_TRACKING_DEPARTURE_DATE": "Delivery date",
  "ORDER_TO_PRINT_TITLE": "Order to print",
  "ORDERS_TO_PRINT_TITLE": "Orders to print",
  "DHL_VALIDATION_ERROR": "Invalid delivery address :",
  "DHL_VALIDATION_ERROR_SITE": "Invalid site address :",
  "DHL_VALIDATION_ERROR_SHIPPING": "Invalid address :",
  "DHL_VALIDATION_ERROR_DELIVERY": "Invalid shipping address :",
  "DHL_VALIDATION_OK_SITE": "Site estimated delivery date: ",
  "DHL_VALIDATION_OK_SITE_SHIPPING": "DHL Delivery OK",
  "DHL_VALIDATION_OK_SHIPPING": "Shipping estimated delivery date: ",
  "DHL_VALIDATION_OK_WITHOUT_DATE": "Site address OK",
  "DHL_VALIDATION_OK_WITHOUT_DATE_SHIPPING": "Address OK",
  "COMMAND_UNTIL": " Estimated delivery on",
  "PLAYERS_LOAD_ERROR": "Players load error",
  "COMPANIES_LOAD_ERROR": "Companies load error",
  "VALIDATION_TICKET_TITLE": "Ticket title",
  "VALIDATION_TICKET_MMBOX_ID": "MMBox id",
  "VALIDATION_TICKET_TODO_TITLE": "Todo title",
  "VALIDATION_TICKET_ASSIGNED_TO": "Assigned to",
  "VALIDATION_TICKET_DESCRIPTION": "Description",
  "VALIDATION_TICKET_DUE_DATE": "Due Date",
  "VALIDATION_ADD_SUCCESS": "Validation ticked added.",
  "VALIDATION_ADD_ERROR": "Validation ticket failed.",
  "TRACKING_ADD_SUCCESS": "Tracking added successfully.",
  "TRACKING_ADD_ERROR": "Update failed for",
  "EMAIL_ALREADY_EXIST": "Email already exist",
  "EMAIL_INVALID": "Email Invalid",
  "ORDERS_LIST_PAGE_TITLE": "Back office | Orders",
  "CLIENT_LIST_PAGE_TITLE": "Back office | Clients List",
  "CLIENT_ADD_PAGE_TITLE": "Back office | Clients Add",
  "CLIENT_EDIT_PAGE_TITLE": "Back office | Clients Edit",
  "DASHBOARD_PAGE_TITLE": "Back office | Dashboard",
  "SITE_LIST_PAGE_TITLE": "Back office | Sites",
  "SITE_ADD_PAGE_TITLE": "Back office | Sites Add",
  "INVOICES_DETAIL_PAGE_TITLE": "Back office | Invoices detail",
  "SITES_BREAD_CRUMB_ADD_TITLE": "Sites Add",
  "SITE_EDIT_PAGE_TITLE": "Back office | Sites Edit",
  "INVOICES_MAIN_PAGE_TITLE": "Back office | Invoices",
  "SITES_SELECTED_LOAD_ERROR": "Sites selected load error",
  "SHIPPINGS_LIST_LOAD_ERROR": "Shippings selected load error",
  "SHIPPING_LIST_PAGE_TITLE": "Back office | Shippings List",
  "SHIPPING_ADD_PAGE_TITLE": "Shipping creation",
  "SHIPPING_EDIT_PAGE_TITLE": "Back office | Shippings Edit",
  "SHIPPING_ADDRESS_LABEL": "Label address",
  "SHIPPING_ADDRESS_KEEP": "Keep this address for this client",
  "ORDER_ADD_SUCCESS": "Order add successfully.",
  "COMPANY_ADD_SUCCESS": "Company add successfully.",
  "ORDER_ADD_ERROR": "Order add error",
  "COMPANY_ADD_ERROR": "Company add error",
  "ORDERS_LOAD_ERROR": "Orders load error",
  "CLIENTS_LIST_LOAD_ERROR": "Clients load error",
  "CLIENTS_LIST_LOAD_BAD_REQUEST_ERROR": "Client List Bad request",
  "COUNTRIES_LOAD_ERROR": "Countries load error",
  "CULTURES_LOAD_ERROR": "Cultures load error",
  "OFFICES_LOAD_ERROR": "Offices load error",
  "CURRENT_CLIENT_LOAD_ERROR": "Current client load error",
  "CURRENT_SITE_LOAD_ERROR": "Current site load error",
  "CURRENT_SUBSCRIPTION_LOAD_ERROR": "Current subscription load error",
  "GROUP_ROLES_LOAD_ERROR": "Group roles load error",
  "USER_CONTEXT_GET_IMPERSONABLE_ERROR": "Impersonable error",
  "MY_CLIENTS_LOAD_ERROR": "My client load",
  "CMS_LOAD_ERROR": "CMS load",
  "MY_SITES_LOAD_ERROR": "My sites load error",
  "PREFERENCES_LOAD_ERROR": "Preferences load error",
  "PRODUCTS_LOAD_ERROR": "Product load error",
  "SITE_ADD_SUCCESS": "Site add success",
  "SITE_ADD_ERROR": "site add error",
  "TIMEZONES_LOAD_ERROR": "Timezone load error",
  "SITES_LOAD_ERROR": "Sites load error",
  "TRANSLATION_LOAD_ERROR": "Translation load error",
  "UPDATE_ERROR": "Update error",
  "DEVICE_MODELS_LOAD_ERROR": "Device models load error",
  "LICENCES_LOAD_ERROR": "Licences load error",
  "PROGRAMS_LOAD_ERROR": "Programs load error",
  "USER_CONTEXT_IMPERSONATE_SUCCESS": "User context impersonate success",
  "USER_CONTEXT_IMPERSONATE_ERROR": "User context impersonate error",
  "USER_CONTEXT_GET_ROLES_ERROR": "User context get roles error",
  "AUTH_GET_USER_INFO_ERROR": "Auth get user info error",
  "ORDER_LIST_ADD_DEVICE_ADD_PLAYER": "Add player",
  "ORDER_LIST_ADD_DEVICE_SUCCESS": "Device added successfully",
  "ORDER_LIST_ADD_DEVICE_ERROR": "Device add error",
  "ORDER_LIST_VALIDATION_TICKET": "Validation ticket",
  "ORDER_LIST_CREATE_SHIPMENT": "Create automatic shipment",
  "ORDER_LIST_PRODUCTION_LINE_CHANGE": "Production Line",
  "ORDER_LIST_PICKUP_TRANSPORTER": "Pickup transporter",
  "ORDER_LIST_PUSH_TO_SALESFORCE": "Push to Salesforce",
  "ORDER_LIST_RESET_ORDER": "Reset order",
  "ORDER_LIST_CLOSE_FORCED_ORDER": "Close order",
  "PUSH_TO_SF_ERROR": " Push to Salesforce error.",
  "PUSH_TO_SF_SUCCESS": " Push to Salesforce success.",
  "ORDER_PICK_UP_DHL_TRACKING_ID": "Tracking id",
  "ORDER_PICK_UP_DHL_SHIP_FROM_TRACKING_ID": "Ship from tracking id",
  "ORDER_PICK_UP_DHL_DEPARTURE_DATE": "Departure date",
  "ORDER_PICK_UP_TRANSPORTER": "Transporter",
  "TRANSPORTERS_LOAD_ERROR": "Transporters load error.",
  "MY_SUBSCRIPTIONS_LOAD_ERROR": "My subscriptions load error.",
  "ORDER_FORM_VALIDATION_TICKET_TITLE": "Title ticket",
  "ORDER_FORM_VALIDATION_TICKET_TITLE_TODO": "Title todo",
  "ORDER_FORM_VALIDATION_TICKET_ASSIGNED_TO": "Assigned to",
  "ORDER_FORM_VALIDATION_TICKET_DESCRIPTION": "Description",
  "ORDER_FORM_VALIDATION_TICKET_DUE_DATE": "Due date",
  "DEVICE_ADD_ERROR": "Device add error",
  "DEVICE_ADOPTION_ADD_ERROR": "",
  "DEVICE_ADD_SUCCESS": "Device added successfully",
  "DEVICE_ID": "Device ID",
  "ORDER_STATUS_ADD_ERROR": "Order status add error",
  "ORDER_FORM_SERVERS": "Server",
  "ORDER_FORM_CMS": "CMS Server",
  "TIMEZONE_CULTURE_LOAD_ERROR": "Timezone/culture load error",
  "WARNING_SELECT_DATA_CHANGE": "This data are not valid anymore",
  "WARNING_SSID_SPACE": "Warning: a space character is present at the beginning or the end of the SSID.",
  "WARNING_PASSWORD_SPACE": "Warning: a space character is present at the beginning or the end of the password.",
  "ORDER_PATCH_SUCCESS": "Order update success.",
  "ORDER_PATCH_ERROR": "Order update error.",
  "ORDER_NOT_ALLOWED_TEXT": "Not allowed to update.",
  "CLIENT_LIST_SITE_COUNT": "Site count",
  "ORDER_LOAD_EXCHANGE_SUCCESS": "Order load exchange success.",
  "ORDER_LOAD_EXCHANGE_ERROR": "Order load exchange error.",
  "PROLONGATION_ADD_SUCCESS": "Prolongation added successfully",
  "PROLONGATION_ADD_ERROR": "Prolongation add error",
  "PILOT_PLAYERS_LOAD_ERROR": "Pilot Players load error.",
  "PILOT_PLAYERS_SALES_DASHBOARD": "Sales dashboard",
  "DAYS": "Days",
  "REASON_PROLONGATION": "What is the reason of the prolongation?",
  "ORDER_LOAD_ERROR": "Order load error",
  "PLAYER_ADOPTION_FAMILIES_LOAD_ERROR": "Families load error",
  "NEW": "New",
  "HAS_PLAYER": "Has player",
  "SET_UP": "In setup",
  "TEST_COMPLETED": "Test completed",
  "PACKED": "Packed",
  "PICKED_UP": "Picked up",
  "SHIP": "Picked",
  "DELIVERED": "Delivered",
  "CLOSED": "Closed",
  "SITE_OFF_TITLE": "Status Off",
  "CONFIRM_SITE_OFF_TITLE": "Do you really want to set the status to Off ?",
  "ACTIONS_MENU_DATATABLE_LIBRARY": "Action on selected elements",
  "ACTIONS": "Actions",
  "PLAYER_LIST_ADD_PLAYER_ORDER_OPENED_WARN_TITLE": "Order opened",
  "PLAYER_LIST_ADD_PLAYER_ORDER_OPENED_WARN_TEXT": "This subscription is in an order process. \n You are not allowed to add a device from that place.",
  "PLAYER_LIST_ADD_PLAYER_SUB_OFF_WARN_TITLE": "Subscription is off",
  "PLAYER_LIST_ADD_PLAYER_SUB_OFF_WARN_TEXT": "This subscription is in OFF status, you cannot add player while it is off.",
  "DEPLOY": "Deploy",
  "EXCHANGE": "Exchange",
  "2": "Deploy",
  "4": "Exchange",
  "SHIPPING_ADDRESS_SAME_AS": "Identical to site address",
  "ERROR_NOT_FOUND_PAGE_TITLE": "Not found",
  "ERROR_ACCESS_DENIED_PAGE_TITLE": "Access denied",
  "ERROR_GONE_PAGE_TITLE": "Data gone",
  "ADD_SHIPPING_DISABLED_IN_MENU": "The selected order(s) should be at status 'Packed' in order to create a pickup.",
  "SITE_FILTER_IS_DEFAULT": "Is default",
  "SITE_FILTER_DEVICE_FRIMWARE": "Firmware ",
  "SITE_FILTER_MAC_ADDRESS": "Mac address ",
  "SITE_FILTER_LAST_CONNECTION": "Last connection ",
  "SITE_FILTER_DEFAULT_PLAYERS_ONLY": "Default players only",
  "SITE_FILTER_DEFAULT_PLAYERS_OTHER": "Other players ",
  "SITE_UPDATE_SUCCESS": "Update subscription successfully",
  "SITE_UPDATE_ERROR": "Subscription update error",
  "REMOVE_PLAYER_MESSAGE": "Are you sure you want to remove this player ?",
  "REMOVE_PLAYER_LIST_UPDATE_NEW_ONE_DEFAULT": "Are you sure you want to remove this player ? Then choose new default one.",
  "REMOVE_PLAYER_ORDER": "Are you sure you want to remove this player ? ",
  "REMOVE_PLAYER_LIST": "Player list",
  "DEFAULT_PLAYER_SUCCESS": "Player default status update success.",
  "DEFAULT_PLAYER_ERROR": "Player default status update error.",
  "REMOVE_PLAYER_SUCCESS": "Player remove success.",
  "CONCEPTS_UPDATE_SUCCESS": "Concepts update success.",
  "REMOVE_PLAYER_ERROR": "Player remove error.",
  "CONCEPTS_UPDATE_ERROR": "Concepts update error.",
  "REMOVE_PROJECT_SUCCESS": "Project remove success.",
  "REMOVE_PROJECT_ERROR": "Project remove error.",
  "RESET_ACTIVATION_CODE_SUCCESS": "Reset hardware success.",
  "RESET_ACTIVATION_CODE_ERROR": "Reset hardware error.",
  "VALIDATION_TICKET_DISABLED_IN_MENU": "The selected order(s) should be deploy or exchange  in order to create a validation ticket or this order already have a ticket.",
  "VALIDATION_TICKET_DISABLED_IN_MENU_2": "This order already have a validation ticket.",
  "SUBSCRIPTION_CLOSE_DISABLED_IN_MENU": "The selected subscription(s) should be attached to the same contract in order to close billing.",
  "SUBSCRIPTION_END_DISABLED_IN_MENU": "All of your subscriptions are closed you are not allow  to update end billing date of them.",
  "TYPE_OF_SHIPPING_RETURN": "Return",
  "TYPE_OF_SHIPPING_DEPLOY": "Deploy",
  "TYPE_OF_SHIPPING_EXCHANGE": "Exchange",
  "TYPE_OF_SHIPPING_EXTRA": "Extra",
  "TYPE_OF_SHIPPING_TO_PTL": "To ptl",
  "TYPE_OF_SHIPPING_COLLECT_RETURN": "Collect & return",
  "TYPE_OF_SHIPPING_TRANSPORTER": "Transporter ",
  "TYPE_OF_SHIPPING_SITE_NAME": "Site name ",
  "TYPE_OF_SHIPPING_UPDATE_CD": "Update cd",
  "SHIPPINGS_NEW_TITLE": "New shipping",
  "COMPANIES_NEW_TITLE": "New company",
  "SHIPPINGS_EDIT_TITLE_MAIN": "General",
  "SHIPPINGS_EDIT_TITLE_SENDING_TYPE": "Sending type",
  "SHIPPINGS_EDIT_TITLE_BILLING": "Billing",
  "SHIPPINGS_EDIT_TITLE_BILLING_COST": "Cost",
  "SHIPPINGS_EDIT_TITLE_BILLING_TAX": "Tax",
  "SHIPPINGS_EDIT_TITLE_BILLING_CODE": "Analytic code",
  "SHIPPINGS_EDIT_TITLE_BILLING_INVOICE": "Invoice",
  "SHIPPING_ADD_SUCCESS": "Shipping add success",
  "SHIPPING_ADD_ERROR": "Shipping add error",
  "SHIPPING_LOAD_ERROR": "Shipping load success",
  "SHIPPING_UPDATE_SUCCESS": "Shipping update success",
  "SHIPPING_UPDATE_ERROR": "Shipping update error",
  "SITE_SUMMARIES_LOAD_ERROR": "Site summaries update error",
  "SHIPPING_LIST_SHIPPING_STATUS": "Update cd",
  "CONTRACT_PURCHASE_ORDER": "Purchase order",
  "CONTRACT_SUBSCRIPTION_COUNT": "Subscription count",
  "CONTRACT_SUBSCRIPTION_COUNTS": "# Subscription",
  "COMPANY_CONTRACT_COUNT": "# Contract",
  "CONTRACT_LIST_PAGE_TITLE": "Contract list",
  "GENERIC_START_DATE": "Start date",
  "CONTRACT_START_DATE": "Contract start ",
  "CONTRACT_END_DATE": "Contract end ",
  "CONTRACT_TIME_LINE_START_DATE": "Billing start",
  "CONTRACT_TIME_LINE_END_DATE": "Billing end",
  "GENERIC_BILLING_START_DATE": "Billing date ",
  "GENERIC_STARTING_DATE": "Starting date",
  "GENERIC_START": "Start ",
  "GENERIC_END_DATE": "End date",
  "GENERIC_END": "End",
  "GENERIC_CLOSE_DATE": "Status Off date",
  "GENERIC_CLOSE": "Status Off",
  "GENERIC_PRICE": "Price",
  "GENERIC_CLIENTS": "Clients",
  "GENERIC_CLIENT": "Client",
  "GENERIC_CLIENTS_NAME": "Client name",
  "GENERIC_ORDER_ID": "Order number",
  "GENERIC_NAME": "Name",
  "GENERIC_ORDERS": "Orders",
  "GENERIC_LIST_ACTIONS": "Actions",
  "GENERIC_LIST_STATUS": "Status",
  "GENERIC_ORDER_LABEL": "Order",
  "GENERIC_AUTOMATIC_PICKUP_TRANSPORTER": "You selected an automatic transporter. It is mandatory to provide a correct Tracking ID.",
  "GENERIC_ORDER_LIST": "Orders",
  "GENERIC_SUPPORT_LIST": "Supports",
  "GENERIC_CLIENT_LIST": "Clients",
  "GENERIC_NAME_LABEL": "Name",
  "GENERIC_NAME_SUFFIX_LABEL": "Suffix if need",
  "GENERIC_NAME_SUFFIX_LABEL2": "Contract Name suffix",
  "GENERIC_OFFICE_LABEL": "Office",
  "GENERIC_SALES_LABEL": "Salesman",
  "GENERIC_SALES_FORCES_ID": "SalesForce code",
  "GENERIC_SALES_FORCES_BRAND_ID": "SalesForce Brand ID",
  "GENERIC_SAP_ID": "SAP code",
  "GENERIC_PROJECT_ID": "Project Code",
  "GENERIC_PRODUCERS_LABEL": "Audio producer",
  "GENERIC_VIDEO_PRODUCERS_LABEL": "Video producer",
  "GENERIC_SERVICES_LABEL": "Service",
  "GENERIC_CREATED_LABEL": "Created",
  "GENERIC_UPDATED": "Updated",
  "GENERIC_CREATED_BY_LABEL": "Created by",
  "GENERIC_UPDATED_LABEL": "Updated",
  "GENERIC_UPDATED_BY_LABEL": "Updated by",
  "GENERIC_LAST_SYNC_FAILED": "Last sync failed",
  "GENERIC_MAC_ADDRESS": "MAC address",
  "GENERIC_SITE": "Site",
  "GENERIC_CITY": "City",
  "GENERIC_ZIP": "Zip",
  "GENERIC_CODE": "Code",
  "GENERIC_ACCOUNTANCY_CODE": "Code",
  "GENERIC_SAP_CODE": "SAP Code",
  "GENERIC_SUBSCRIPTION_NAME": "Subscription",
  "GENERIC_COUNTRY": "Country",
  "GENERIC_SEARCH": "Search",
  "GENERIC_RESET": "Reset",
  "GENERIC_QUICK_SEARCH": "Quick search",
  "GENERIC_SEARCH_PLAYER": "Search player",
  "GENERIC_PLAYERS": "Players",
  "GENERIC_FAMILIES": "Families",
  "GENERIC_ADOPTION_CODE": "Adoption code",
  "GENERIC_SERIAL_NUMBER": "Serial number",
  "GENERIC_OFFICE": "Office",
  "GENERIC_OFFICES": "Offices",
  "GENERIC_SALES": "Sales",
  "GENERIC_FILTER": "Filter",
  "GENERIC_ASSIGN": "Assign",
  "GENERIC_TVA": "Tva",
  "GENERIC_VAT": "VAT",
  "GENERIC_PLAYER_NAME": "Player name",
  "GENERIC_PLAYER_INFO": "Player info",
  "GENERIC_COMMENT": "Comments",
  "GENERIC_SALESFORCE_ID": "SF Account ID",
  "GENERIC_COMMENT_MESSAGE": "This order has comments.",
  "GENERIC_ADD": "Add",
  "GENERIC_EDIT": "Edit",
  "GENERIC_UNDO": "Undo",
  "GENERIC_SAVE": "Save",
  "GENERIC_COMPANIES": "Companies",
  "GENERIC_LIST": "List",
  "GENERIC_TYPE": "Type",
  "GENERIC_PUBLICATION": "This order has at least one available publication.",
  "GENERIC_PUBLICATION_EMPTY": "This order has no publication.",
  "GENERIC_PAGES": "pages",
  "GENERIC_PAGE": "page",
  "GENERIC_EXTERNAL_ID": "External id",
  "GENERIC_SUBSCRIPTION_COUNT": "Subscription Count",
  "GENERIC_ADDRESS": "Address",
  "GENERIC_CULTURES": "Cultures",
  "GENERIC_LANGUAGE": "Language",
  "GENERIC_SITES": "Sites",
  "GENERIC_REPORTS": "Reports",
  "GENERIC_REPORTS_PILOT_PLAYERS": "Pilot players",
  "GENERIC_REPORTS_SUPPORT": "Support",
  "GENERIC_REPORTS_PILOT_PLAYERS_PROLONGATION": "Prolongation",
  "GENERIC_NUMBER_AUDIO_PLAYERS": "Number of audio players: ",
  "GENERIC_NUMBER_VIDEO_PLAYERS": "Number of video players: ",
  "GENERIC_REPORTS_PILOT_PLAYERS_ADD_PROLONGATION": "Additional period of use",
  "GENERIC_LOADING": "LOADING...",
  "GENERIC_DEVICE_MODEL": "Model",
  "GENERIC_SHIPPINGS": "Shippings",
  "GENERIC_ORDER": "Order",
  "GENERIC_OK": "Ok",
  "GENERIC_LAST_CONNECTION": "Last connection",
  "GENERIC_FIRMWARE": "Firmware",
  "GENERIC_MODEL": "Model",
  "GENERIC_IS_DEFAULT": "Is default",
  "GENERIC_DEVICE_ID": "Device id",
  "GENERIC_PRODUCT_NAME": "Product name",
  "PROJECT_LIST_NAME": "Name",
  "PROJECT_LIST_SF_PROJECT_ID": "SF Project ID",
  "PROJECT_SAP_PROJECT_ID": "SAP Project ID",
  "GENERIC_PRODUCT": "Product",
  "GENERIC_GENERAL_INFO": "General Information",
  "GENERIC_OPTIONS_AUDIO": "Options audio",
  "GENERIC_OPTIONS_VIDEO": "Options video",
  "GENERIC_REMOVE": "Remove",
  "GENERIC_RESET_CODE": "Reset",
  "GENERIC_REMOVED": "Removed",
  "GENERIC_LAST_INVOICE_CALCULATION": "Invoice until",
  "GENERIC_REMOVE_PLAYER": "Remove player",
  "GENERIC_STATUS": "Status",
  "GENERIC_CREATED": " Created",
  "GENERIC_REF_NAME": " Ref name",
  "GENERIC_DELETED": "Deleted",
  "GENERIC_RECURRENCE": "Recurrence",
  "GENERIC_INVOICE_RECURRENCE": "Recurrence",
  "GENERIC_DATE": "Date",
  "GENERIC_ADJUSTMENT": "Adjustment",
  "GENERIC_COMPANY": "Company",
  "GENERIC_ANOMALIES": "Anomalies",
  "PLAYER_CONFIGURATION_EDIT_LOAD_ERROR": "Player configuration edit load error",
  "PLAYER_CONFIG_DEF_LIST_LOAD_ERROR": "Player configuration definition load error",
  "DESCRIPTION_BaseUrl": "Update url",
  "DESCRIPTION_ConfigPath": "Config download path",
  "DESCRIPTION_contentbootFromServer": "Boolean value indicating whether to update the Url Server",
  "DESCRIPTION_contentserverUrl": "Update server url",
  "DESCRIPTION_FirmwarePath": "Firmware download path",
  "DESCRIPTION_hardwareaudioOut0masterSoundLevel": "The main sound level",
  "DESCRIPTION_hardwarevideoOut0rotation": "Image rotation (in degrees)",
  "DESCRIPTION_LoggingRate": "Frequency of sending activity logs",
  "DESCRIPTION_LogPath": "Log upload path",
  "DESCRIPTION_MediaPath": "Media path to download",
  "DESCRIPTION_MinimumFirmwareVersion": "Minimum firmware version supported by the player",
  "DESCRIPTION_netethernetdhcpenabled": "Boulean value to indicate if the player uses DHCP",
  "DESCRIPTION_netethernetdnsServers": "DNS server address",
  "DESCRIPTION_netethernetenabled": "Network card activation",
  "DESCRIPTION_netethernetgateway": "Player's gateway IP address",
  "DESCRIPTION_netethernetip": "IP address configured for the player",
  "DESCRIPTION_netethernetnetmask": "Player subnet mask",
  "DESCRIPTION_netwifiauthentication": "Password for wifi",
  "DESCRIPTION_netwifienabled": "Activation of the wifi card",
  "DESCRIPTION_netwifissid": "Login for WIFI connection",
  "DESCRIPTION_PlayLogRate": "Frequency of sending broadcast logs",
  "DESCRIPTION_PrefetchDelay": "Frequency of media preload cycle",
  "DESCRIPTION_RebootTime": "Player restart time",
  "DESCRIPTION_RefreshRate": "Update frequency",
  "DESCRIPTION_schedulereboottime": "Player restart time",
  "DESCRIPTION_TaskPath": "Tasks download path",
  "DESCRIPTION_timeautoUpdateprotocol": "Time update mode",
  "DESCRIPTION_timetimeZone": "Player timezone",
  "DESCRIPTION_UseDSServerV2": "Boulean value indicating if we are using version 2 of the update server",
  "DESCRIPTION_FirmwareUpdateTime": "Automatic firmware update time",
  "DESCRIPTION_EndUpdate": "Maximum update end time",
  "DESCRIPTION_ForceProgram": "Active automatiquement le program 1 au redémarrage",
  "DESCRIPTION_Random": "Automatically activates program 1 on restart",
  "DESCRIPTION_StartUpdate": "Update start time",
  "DESCRIPTION_Telnet": "Activation of the local telnel server",
  "DESCRIPTION_UpdateInBackground": "Boulean value indicating whether the updates are done in the background or not",
  "DESCRIPTION_VolumeReduction": "Volume difference between music and commercials (decibel value (x3))",
  "DESCRIPTION_Serverurl": "Configuration server url",
  "DESCRIPTION_UpdatePath": "Download path for updates",
  "DESCRIPTION_UseTCPV2": "Volume difference between music and commercials (decibel value (x3))",
  "DESCRIPTION_IsBlankScreenEnabled": "TV should be shutdown when the player isn't playing",
  "FILTER_SEARCH_OPTION": "Search an option",
  "ADD_OPTION_TITLE": "Add options",
  "PLAYER_CONFIGURATION_TITLE": "Player configuration",
  "GENERIC_CONTRACTS": "Contracts",
  "PLAYER_CONFIG_UPDATE_SUCCESS": "Player configuration update success",
  "PLAYER_CONFIG_UPDATE_ERROR": "Player configuration update error",
  "CONTRACT_ADD_NEW_RULE": "Add new rule",
  "COMPANY_LIST_PAGE_TITLE": "Back office | Companies list",
  "COMPANY_DISPLAY_PAGE_TITLE": "Back office | Companies display",
  "COMPANY_LOAD_ERROR": "Company load error",
  "COMPANY_PREVIEW_INVOICES_ERROR": "Preview load error",
  "COMPANY_LOGISTIC_CODE": "Company load error",
  "GENERIC_ACTIVE": "Active",
  "GENERIC_GROUP_BY_SITE": "Group by site",
  "GENERIC_GROUP_BY_SITE_ON_THE_INVOICE": "Group by site on invoice",
  "GENERIC_COMPANY_NAME": "Company",
  "GENERIC_INVOICES_DETAIL_SAP_INVOICES_TOTAL": "SAP total",
  "GENERIC_INVOICES_DETAIL_SYNC_DATE": "Sync date",
  "GENERIC_INVOICES_DETAIL_SALES_FORCE_ID": "Salesforce ID",
  "GENERIC_COVERS_START": "Start cover",
  "GENERIC_COVERS_END": "End cover",
  "GENERIC_COUNT": "Count",
  "GENERIC_UNIT_PRICE": "Unit price",
  "GENERIC_TOTAL": "Total",
  "GENERIC_PROJECT_NAME": "Project name",
  "GENERIC_SF_IDENTIFIER": "Salesforce project id",
  "GENERIC_SF_IDENTIFIER_PLACEHOLDER": "PRJ5485_215462 or a007R00000w1gVZ",
  "GENERIC_PROJECT_CREATION": "Project link",
  "PROJECT_CREATION_MISMATCHING_FAILED_1": "Company is mismatching between Salesforce Project and Client office:",
  "PROJECT_CREATION_MISMATCHING_FAILED_2": "is different from ",
  "GENERIC_LINK": "Link",
  "GENERIC_SPLIT": "Split",
  "GENERIC_INVOICE_NUMBER": "Number",
  "GENERIC_INVOICE_IS_ADJUSTMENT": "Adjustment",
  "CONTRACT_FORM_START": "Start date",
  "CONTRACT_FORM_END": "End date",
  "CONTRACT_FORM_ISINDEX": "Index",
  "CONTRACT_FORM_RECURRENCE": "Recurrence",
  "CONTRACT_FORM_RECURRENCE_SHIFT_MONTH_ALLOW": "Choose a date not matching with trimester",
  "CONTRACT_FORM_RECURRENCE_SHIFT_MONTH": "Starting period",
  "CONTRACT_FORM_SPLIT": "Split",
  "CONTRACT_FORM_PRODUCT_ID": "Product",
  "CONTRACT_FORM_SLA": "Sla",
  "CONTRACT_FORM_SLA_TITLE": "Service level agreement",
  "CONTRACT_FORM_CUSTOMINVOICE": "Invoice internal comments",
  "CONTRACT_FORM_RETRACTATION_DELAY": "Pre-notice",
  "CONTRACT_FORM_RETRACTATION": "Pre-notice",
  "CONTRACT_FORM_RETRACTATION_UNITE": "(Month)",
  "CONTRACT_FORM_PAYMENT": "Payment",
  "CONTRACT_FORM_PAYMENT_UNITE": "(Days)",
  "CONTRACT_FORM_DELETED": "Deleted",
  "CONTRACT_FORM_CURRENCY": "Currency",
  "CONTRACT_FORM_TRIGGER_START_TITLE": "Billing start (trigger)",
  "CONTRACT_FORM_TRIGGER_START": "Trigger",
  "CONTRACT_FORM_NAME": "Name",
  "CONTRACT_FORM_UUID": "Uuid",
  "CONTRACT_FORM_ID": "Id",
  "CONTRACT_FORM_RULES_PURCHASE_ORDER": "Purchase order",
  "CONTRACT_FORM_RULES_SETUP_FEE": "Setup fee",
  "CONTRACT_FORM_RULES_COMMUNICATION_FEE": "Communication fee",
  "CONTRACT_FORM_RULES_MAINTENANCE_FEE": "Maintenance fee",
  "CONTRACT_FORM_RULES_ADMIN_FEE": "Admin fee",
  "CONTRACT_FORM_RULES_ADMIN_FEE_PERCENT": "Admin fee %",
  "CONTRACT_FORM_RULES_MUSIC_SERVICE_FEE": "Music service",
  "CONTRACT_FORM_RULES_PROJECT_MANAGER_FEE": "Project management",
  "CONTRACT_FORM_RULES_SOFTWARE_SERVICE_FEE": "Software service",
  "CONTRACT_FORM_RULES_INFO_BULL_PRE_NOTICE": "notice period for the client to terminate the contract to be specified by month",
  "CONTRACT_FORM_RULES_INFO_BULL_SPLIT": "Split invoicing is the way the bill will be separated. It can be by site, client, country, contract or simply by company." +
    " Splitting by company or PO will regroup all contract for this company or with the same PO and company on the same invoice",
  "CONTRACT_FORM_RULES_INFO_BULL_PRICE": "You have different option for price, you can manage fixed price, price evolution by number of player,price evolution by time, price by connection (online/offline).",
  "CONTRACT_FORM_RULES_FEE_BY_INVOICE": "(Invoice/Contract)",
  "CONTRACT_FORM_RULES_FEES": "Fees ",
  "CONTRACT_FORM_RULES_PRICE": "Price",
  "CONTRACT_FORM_RULES_PURCHASE_PRICE": "Purchase price",
  "CONTRACT_FORM_RULES_LICENSE": "License",
  "CONTRACT_FORM_RULES_BILLING_PRODUCT": "Billing product",
  "CONTRACT_FORM_RULES_THIRD_PARTY_LICENSE": "Third party license",
  "RULES_ADD_SUCCESS": "Rules add success",
  "LANGUAGE_TEXT_UPDATE_SUCCESS": "Language text update success",
  "RULES_ADD_ERROR": "Rules add error",
  "RULES_LOAD_ERROR": "Rules load error",
  "RULES_UPDATE_SUCCESS": "Rules update success",
  "RULES_UPDATE_ERROR": "Rules update error",
  "CONTRACT_FORM_CUSTOM_INVOICE": "Invoice",
  "CONTRACT_FORM_INVOICING_DATE": "Contract date",
  "CONTRACT_FORM_INDEXATION_OF_CONTRACT": "Indexation",
  "CONTRACT_FORM_PERIODIC_ADJUSTMENT_OF_CONTRACT": "Invoice new player monthly",
  "CONTRACT_FORM_PO_REQUIRED": "Purchase order",
  "CONTRACT_FORM_PO_REQUIRED_TITLE": "Purchase order",
  "CONTRACT_FORM_SETTING_TITLE": "Setting",
  "CONTRACT_FORM_CUSTOM_INVOICE_TITLE": "Invoicing internal comments",
  "CONTRACT_FORM_IS_INDEX": "Is index",
  "CONTRACT_ADD_SUCCESS": "Contract add/update success",
  "CONTRACT_ADD_ERROR": "Contract add error",
  "CONTRACT_DUPLICATION_SUCCESS": "Contract duplication success",
  "PROJECT_LINK_SUCCESS": "Project Link success",
  "CONTRACT_DUPLICATION_ERROR": "Contract duplication error",
  "PROJECT_CREATION_SUCCESS": "Project creation success",
  "PROJECT_CREATION_ERROR": "Project creation error",
  "PROJECT_LINK_ERROR": "Project link error",
  "PROJECT_LINK_MESSAGE_ERROR": "This project is not found in the Salesforce database. Please create it before association.",
  "CONTRACT_NEW_TITLE": "Add contract",
  "CONTRACT_DETAIL_PAGE_TITLE": "Contract display",
  "GENERIC_CONTRACT_NAME": "Contract",
  "CONTRACT_FORM_RULES_FEE_ONCE_OFF": "(Once-off/New subscription)",
  "CONTRACT_FORM_RULES_FEE_MONTHLY": "(Monthly/Subscription)",
  "CONTRACT_FORM_RULES_REWARDS": "Reward",
  "CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_ON": "Online",
  "CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_OFF": "Offline",
  "CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_PLACEHOLDER": "Price",
  "CONTRACT_FORM_PRICE_EVOLUTION": "Price by connection",
  "CONTRACT_FORM_RULES_OPTIONS": "Options",
  "CONTRACT_FORM_RULES_PRICE_EVOLUTION_TIME": "Price evolution time",
  "CONTRACT_FORM_RULES_PRICE_EVOLUTION_VOLUME": "Price evolution volume",
  "CONTRACT_FORM_RULES_PRICE_TIME_START": "Start (month)",
  "CONTRACT_FORM_RULES_PRICE_TIME_END": "End (month)",
  "CONTRACT_FORM_RULES_PRICE_TIME_PRICE": "Price",
  "DATE_PLACEHOLDER": "date",
  "CONTRACT_FORM_RULES_PRICE_VOLUME_MIN": "Min",
  "CONTRACT_FORM_RULES_PRICE_VOLUME_MAX": "Max",
  "CONTRACT_FORM_RULES_PRICE_VOLUME_PRICE": "Price",
  "CONTRACT_FORM_RULES_OPTION_OBJECT": "Object",
  "CONTRACT_FORM_RULES_OPTION_AMOUNT": "Amount",
  "CONTRACT_FORM_RULES_OPTION_VARIANCE": "Variance",
  "CONTRACT_FORM_RULES_REWARD_NAME": "Name",
  "CONTRACT_FORM_RULES_REWARD_VALUE": "Value",
  "PLAYER_LIST_ICON_TITLE_SET_DEFAULT": "Set as default",
  "SET_DEFAULT_MODAL_TITLE": "Set as default",
  "SET_DEFAULT_PLAYER_CONFIRMATION_MESSAGE": "Are you sure to set this player as Default ? It will set the other as non default.",
  "SET_DEFAULT_PLAYER_CONFIRMATION_BUTTON": "Set as default",
  "PLAYER_QUICK_SEARCH_PLACEHOLDER": "Player quick search",
  "QUICK_SEARCH_DIALOG_TITLE": "Results",
  "PLAYER_IN_STOCK": "Player in stock",
  "PLAYER_ID": "Player",
  "PLAYER_SITE": "Site",
  "PLAYER_CLIENT": "Client",
  "GOTO_PLAYER": "View subscription",
  "QUICK_SEARCH_DEVICE_NOT_FOUND": "Device not found",
  "SITE_FILTER_PLAYER_SHOW_HISTORY": "Show history",
  "CONTRACT_LINK_MODAL_BILLING_START": "Billing start",
  "END_BILLING_START_DATE": "Start date",
  "CONTRACT_LINK_MODAL_CONTRACT_START": "Contract start",
  "CONTRACT_LINK_MODAL_CONTRACT_NAME": "Contract name",
  "CONTRACT_LINK_MODAL_BILLING_END": "Billing end",
  "CONTRACT_LINK_MODAL_CONTRACT_END": "Contract end",
  "CONTRACT_LINK_MODAL_COMPANY": "Company",
  "CONTRACT_LINK_MODAL_COMPANY_PLACEHOLDER": "Search by name",
  "CONTRACT_LINK_MODAL_CONTRACT": "Contract",
  "CONTRACT_LINK_MODAL_CONTRACT_PLACEHOLDER": "Search by name",
  "CONTRACT_LINK_MODAL_SUBSCRIPTIONS": "Subscriptions",
  "CONTRACT_LINK_MODAL_SUBSCRIPTIONS_PLACEHOLDER": "Search by name",
  "CONTRACT_LINK_MODAL_LINK_CONTRACT": "Link contract",
  "CONTRACT_LINK_MODAL_LINK_EXISTING_CONTRACT": "Link existing contract",
  "INVOICES_GET_LAST_NUMBER": "Last invoice numbers",
  "CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS": "Link subscriptions",
  "CONTRACT_LINK_MODAL_INVOICES_MANAGEMENT": "Invoices Management",
  "CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS_IS_SF_INVOICES": "Invoiced via Salesforce",
  "CONTRACT_LINK_MODAL_LINK": "Link",
  "CONTRACT_DUPLICATE_MODAL_BTN": "Duplicate",
  "CONTRACT_MODAL_SELECTED_SUBSCRIPTIONS": "Selected subscription(s):",
  "CONTRACT_LINK_MODAL_LINK_CONTRACT_COMPANY_SUBSCRIPTIONS": "Link Company contract and subscriptions",
  "CONTRACT_DUPLICATE_MODAL_TITLE": "Duplication contract",
  "CONTRACT_LINK_SUCCESS": "Contract link success",
  "CONTRACT_LINK_ERROR": "Contract link error",
  "GENERIC_PUBLICATION_NAME": "Name",
  "GENERIC_PUBLICATION_PACKAGE_ID": "Package Id",
  "GENERIC_PUBLICATION_TYPE": "Type",
  "GENERIC_PUBLICATION_VERSION": "Version",
  "GENERIC_PUBLICATION_STARTDATE": "Start date",
  "GENERIC_PUBLICATION_ENDDATE": "End date",
  "GENERIC_PUBLICATION_CREATED": "Created",
  "GENERIC_PUBLICATION_TRANSFERMODE": "Sent",
  "PUBLICATIONS_LOAD_ERROR": "Failed to load the publication list",
  "GENERIC_PUBLICATION_STATUS": "Status",
  "PURCHASE_ORDER_NOT_ACTIVE": "Purchase order not active",
  "RULES_IS_INVOICED": "Rule already invoiced  ,if you need to update this rules then create new rules",
  "RULES_IS_NOT_ALLOW": "Your Rule(s) already covered you contract",
  "WARNING_ORIENTATION_CHANGE_AFFECT_MEDIA": "This change may prevent your program to run correctly if the orientation is not the same in DS Manager",
  "ORDERS_DETAILS_SHIPPING_ATTACHED_MESSAGE": "No shipping detected",
  "SETUP_PLAYER_SUCCESS": "setup player success",
  "SETUP_PLAYER_ERROR": "setup player error",
  "GENERIC_SETUP_PLAYER": "Setup player",
  "GENERIC_SETUP_PLAYER_MESSAGE": "Are you sure you want to setup this player ?",
  "GENERIC_VALIDATION_INVOICES_MESSAGE": "Are you sure you want to validate this task ?",
  "GENERIC_CLEAR_CALCULATION_MESSAGE": "Are you sure you want to clear calculation ?",
  "ORDER_EXCHANGE_SUBSCRIPTION_CLOSED": "Subscription close",
  "CONTRACT_DUPLICATE_MODAL_CONTRACT": "Duplicate with rule",
  "CONTRACT_LINKED_CHECKBOX_MODAL": "Subscription(s) without a contract",
  "INVOICES_MANAGEMENT_CLEAR_INVOICES_CHECKBOX_MODAL": "Clear invoices",
  "INVOICES_MANAGEMENT_USE_PERIODIC_CHECKBOX_MODAL": "Use periodic adjusment for next period",
  "CONTRACT_DUPLICATION_MODAL_TITLE": "Duplicate contract",
  "CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE": "Edit billing dates",
  "SUBSCRIPTIONS_STATUS_EXPLOIT": "Exploit",
  "SUBSCRIPTIONS_STATUS_DEMO": "Pilot",
  "SUBSCRIPTIONS_STATUS_OFF": "Off",
  "SUBSCRIPTIONS_STATUS_TO_OFF": "To off - no update",
  "SUBSCRIPTIONS_STATUS_STOP": "Stop",
  "SUBSCRIPTIONS_STATUS_BANKRUPTCY": "Bankruptcy",
  "GENERIC_INVOICES": "Invoices",
  "REMOVE_PLAYER_IS_LOST_OR_SOLD": "Player lost or sold",
  "REASON_REMOVE": "What is the reason ?",
  "INVOICES_LOAD_ERROR": "Invoices load error",
  "INVOICES_TRIGGER_BUTTON": "Trigger Invoices",
  "INVOICES_TRIGGER_MODAL_TITLE": "Start billing",
  "INVOICES_TRIGGER_PERIOD": "Period",
  "INVOICES_TRIGGER_RECURRENCE_Q1": "Generate the first trimester (Q1)",
  "INVOICES_TRIGGER_RECURRENCE_Q2": "Generate second trimester (Q2 + adjustment)",
  "INVOICES_TRIGGER_RECURRENCE_Q3": "Generate second trimester (Q3  + adjustment)",
  "INVOICES_TRIGGER_RECURRENCE_Q4": "Generate second trimester (Q4  + adjustment)",
  "INVOICES_TRIGGER_RECURRENCE_A2": "Generate February (A2)",
  "INVOICES_TRIGGER_RECURRENCE_A3": "Generate March (A3)",
  "INVOICES_TRIGGER_RECURRENCE_A5": "Generate May (A5)",
  "INVOICES_TRIGGER_RECURRENCE_A6": "Generate June (A6)",
  "INVOICES_TRIGGER_RECURRENCE_A8": "Generate August (A8)",
  "INVOICES_TRIGGER_RECURRENCE_A9": "Generate September (A9)",
  "INVOICES_TRIGGER_RECURRENCE_A11": "Generate November (A11)",
  "INVOICES_TRIGGER_RECURRENCE_A12": "Generate December (A12)",
  "GENERIC_INVOICES_HISTORY": "Invoices history",
  "INVOICES_HISTORY_STARTED": "Started",
  "INVOICES_HISTORY_COMPLETED": "Completed",
  "INVOICES_HISTORY_ADJUSTMENT_ANNUAL": "Adjustment annual",
  "INVOICES_HISTORY_ADJUSTMENT_BI": "Adjustment bi annual",
  "INVOICES_VALIDATION_ADD_SUCCESS": "Invoices validation success",
  "INVOICES_TRIGGER_SUCCESS": "Invoices trigger success",
  "INVOICES_VALIDATION_ADD_ERROR": "Invoices validation error",
  "INVOICES_TRIGGER_ERROR": "Invoices trigger error",
  "INVOICES_TRIGGER_BUTTON_TITLE": "Start billing",
  "INVOICES_VALIDATION_BUTTON_TITLE": "Invoices validation",
  "INVOICES_VALIDATION_CLEAR_BUTTON_TITLE": "Clear calculation",
  "INVOICES_VALIDATION_REPROCESS_BUTTON_TITLE": "Reprocess calculation",
  "INVOICES_LINE_CODE": "code",
  "INVOICES_LINE_NAME": "Line name",
  "BILLING_CALCULATION_FILES": "Get file",
  "BILLING_VALIDATION_FILES": "Get file",
  "PLAYER_LIST_ACTIVE_CODE": "Activation code",
  "PLAYER_LIST_LICENCE_MODIFICATION_DATE": "Licence Modification Date",
  "PLAYER_LIST_ACTIVATION": "Activated",
  "INVOICES_VALIDATION_FILES_ERROR": "Invoices get validation files error",
  "SITE_LIST_MERGE_SITE_CLIENT": "Move site",
  "SITE_LIST_MERGE_SUBSCRIPTION_SITE": "Move subscriptions",
  "SITE_LIST_MERGE_SITE_CLIENT_BTN": "Move",
  "SITE_LIST_MERGE_SITE_CLIENT_INPUT": "Target client",
  "SITE_LIST_MERGE_SUBSCRIPTION_SITE_INPUT": "Target site",
  "SITE_LIST_MERGE_CLIENT_SELECTED_SITE_LABEL": "Sites selected :",
  "SITE_LIST_MERGE_CLIENT_MESSAGE": "You will move {{countSites}} sites to the client {{clientName}} and you need to publish new content on your player, you have 10 minutes before your screen become black.",
  "SUBSCRIPTION_LIST_MERGE_SITE_MESSAGE": "You will move {{countSubscription}} subscription(s) to the site {{siteName}}.",
  "SITE_LIST_MERGE_CLIENT_MESSAGE_ERROR": "Your selected client is the same than the current client",
  "SITE_LIST_MERGE_SITE_MESSAGE_ERROR": "Your selected site is the same than the current site",
  "INVOICES_LOGISTIC_JOURNAL": "Journal",
  "GENERIC_INVOICES_DETAIL_LIST": "Invoices detail",
  "GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE": "Logistic code",
  "GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE_2": "Code",
  "GENERIC_INVOICES_DETAIL_LIST_UNITE_PRICE": "Unit price",
  "GENERIC_INVOICES_DETAIL_LIST_TOTAL": "Total",
  "MERGE_SUBSCRIPTION_SUCCESS": "Site moved success",
  "MERGE_SUBSCRIPTION_ERROR": "Site moved error",
  "CONTRACT_LIST_PRICE_EMPTY_DATA": "No price for this period",
  "CONTRACT_BREAD_CRUMB_ADD_TITLE": "Contract creation",
  "REPORT_SUPPORT_LIST_VECTOR": "Vector",
  "GENERIC_FROM_DATE": "From",
  "GENERIC_TO_DATE": "To",
  "GENERIC_CLOSE_TICKET": "Closed Ticket",
  "GENERIC_NEW_TICKET": "New Ticket",
  "GENERIC_CLOSE_TODOS": "Closed todo's",
  "GENERIC_ASSIGNED_TODOS": "Assigned Todo's",
  "GENERIC_EXCHANGE_CREATED": "Exchange created",
  "GENERIC_NO_DATA": "No data",
  "SUPPORT_LIST_LOAD_ERROR": "Support list load error",
  "GENERIC_BLOCKED": "Blocked           ",
  "PRODUCTION_LINE_BXL": "Production line Brussels",
  "PRODUCTION_LINE_SHA": "Production line Shanghai",
  "PRODUCTION_LINE_HON": "Production line Hong kong",
  "PRODUCTION_LINE_TRI": "Production line Trieste",
  "PRODUCTION_LINE_MIL": "Production line Milano",
  "PRODUCTION_LINE_PAR": "Production line Paris",
  "PRODUCTION_LINE_EXT": "External Partners",
  "PRODUCTION_LINE": "Production line",
  "END_BILLING_SUCCESS": "End billing success",
  "END_BILLING_ERROR": "End billing error",
  "ENDLESS_END_DATE": "Endless end date",
  "BILLING_LINKED_CONFIRMATION": "Some of the selected subscriptions are already linked to a contract and company, Are you sure that you want to update the billing date in case of conflicts for these subscriptions ?",
  "ANOMALY_SUBSCRIPTION_LIST_PAGE_TITLE": "Subscriptions anomalies lists",
  "ANOMALY_LIST_PAGE_TITLE": "Anomalies lists",
  "GENERIC_OFF": "New sites off",
  "GENERIC_DAILY": "Daily",
  "GENERIC_MONTHLY": "Monthly",
  "GENERIC_WEEKLY": "Weekly",
  "GENERIC_DELIVERY": "Missing delivery date",
  "GENERIC_UNLINK": "Missing link",
  "ANOMALY_LIST_SET_DELIVERY": "Set delivery date",
  "ANOMALY_DELIVERY_WARNING": "Delivery date update warning , some of your selected item use Fedex ou DHL , Contact your dev@storever.com",
  "ANOMALY_DELIVERY_ERROR": "Delivery date update error, your selected item use Fedex ou DHL , Contact your dev@storever.com",
  "ANOMALY_DELIVERY_SUCCESS": "Delivery date update success",
  "CREATION_OF_NEW_RULES": "New price",
  "IMPORT_EXCEL_FILE": "Export",
  "PRODUCTION_LINE_CHANGE_ERROR": "Production Line change error",
  "PRODUCTION_LINE_CHANGE_SUCCESS": "Production Line change  success",
  "PRODUCTION_LINE_DISABLED_IN_MENU": "The selected order(s) should be at status 'New' in order to change production line.",
  "SELECTED_SUBSCRIPTION": "selected subscription",
  "musicService": "Music service",
  "projectManagement": "Project management",
  "softwareService": "Software service",
  "materialLocation": "Hardware rental",
  "EXPLOIT_WITH_BILLING_END": "Exploit with end billing",
  "EXPLOIT_WITH_BILLING_END_UPDATE": "Update subscription",
  "GENERIC_PRICE_ZERO": "Contract price Zero",
  "GENERIC_PRICE_ZERO_UPDATE": "Update contract",
  "GENERIC_BLOCKED_INVOICING": "Blocked invoicing",
  "GENERIC_BLOCKED_INVOICING_UPDATE": "Go to the Company",
  "GENERIC_CLOSE_SUBSCRIPTION": "Close subscription",
  "GENERIC_CLOSE_SUBSCRIPTIONS": "Close subscriptions",
  "GENERIC_ADD_SF_PROJECT": "Edit SF project",
  "GENERIC_ADD_PROJECT": "Set SF project",
  "GENERIC_SEND_EMAIL_FINANCE": "Send email to finance",
  "GENERIC_UPDATE_DATA_TO_SAP": "Please update data for this company in SAP tool",
  "CLEAR_CALCULATION_SUCCESS": "Clear calculation success",
  "CLEAR_CALCULATION_ERROR": "Clear calculation error",
  "REPROCESS_CALCULATION_SUCCESS": "Reprocess calculation success",
  "REPROCESS_CALCULATION_ERROR": "Reprocess calculation error",
  "SUBSCRIPTION_SELECTED_WITH_DIFFERENT_PRODUCT": "The contract is only for one product. The selected subscriptions have different product, please remove subscriptions to have only one product.",
  "REPORT_SABAM_MUSIC_DATABASE_FILE_ERROR": "Failed to download the report",
  "REPORT_SUPPORT_FILE_ERROR": "Failed to download the report",
  "REPORT_SABAM_MUSIC_DATABASE_FILE_LINK": "Download Sabam music database",
  "REPORT_PLAYER_SUBSCRIPTION_OFF_PENDING_DEVICE": "Report player subscription off with pending device.",
  "REPORT_PLAYER_SUBSCRIPTION_MORE_THEN_ONE_PLAYER": "Report player subscription with more then one player.",
  "REPORT_PLAYER_WITH_DATE_RANGE": "Report players with date range",
  "REPORT_SUPPORT_WITH_DATE_RANGE": "Report support with date range",
  "REPORT_STEMRA_WITH_DATE_RANGE": "Stemra report site list",
  "REPORT_NEW_CHURN_SUBSCRIPTION_WITH_DATE_RANGE": "New and Churn subscription report by country",
  "REPORT_SUPPORTS_WITH_DATE_RANGE": "Report Support with date range",
  "DASHBOARD_LINK": "Dashboard",
  "DASHBOARD_SALES_MAIN_TITLE": "Sales dashboard",
  "DASHBOARD_ORDERS_MAIN_TITLE": "Orders dashboard",
  "DASHBOARD_SALES_LOAD_ERROR": "Failed to load statistics",
  "DASHBOARD_SALES_INPUT_YEAR_LABEL": "Year",
  "DASHBOARD_SALES_TABLEHEADER_NEW_SUBSCRIPTIONS": "New Subscriptions",
  "DASHBOARD_SALES_TABLEHEADER_LOST_SUBSCRIPTIONS": "Churn",
  "DASHBOARD_SALES_TABLEHEADER_AVERAGE_PRICE": "Average price (€)",
  "DASHBOARD_SALES_TABLEHEADER_GOAL_SUSCRIPTIONS": "Yearly target subscriptions",
  "DASHBOARD_SALES_TABLEHEADER_HARDWARE": "Hardware (€)",
  "DASHBOARD_SALES_TABLEHEADER_GOAL_HARDWARE": "Target Hardware (€)",
  "MODAL_TITLE_AUTOMATIC_TESTING": "Test failed",
  "MODAL_TITLE_AUTOMATIC_SETUP": "Setup failed",
  "MODAL_AUTOMATIC_PROCESS_REPORT_TEST": "You can retry your task by clicking on retry or you can manually validate you task by clicking on Manual validation ",
  "MODAL_AUTOMATIC_PROCESS_REPORT_SETUP": "You can retry your task by clicking on retry or you can manually validate you task by clicking on Manual validation ",
  "MODAL_AUTOMATIC_SETUP_ERROR": "An error has occurred during the setup process. ",
  "MODAL_AUTOMATIC_TEST_ERROR": "An error has occurred during the test process. ",
  "MODAL_AUTOMATIC_TEST_ERROR_SYNC_DATA": "Sync with Salesforce to fix the data.",
  "MODAL_AUTOMATIC_SETUP_ERROR_RETRY": " - Click RETRY to execute it again.",
  "MODAL_AUTOMATIC_SETUP_ERROR_CONTINUE": " - Click CONTINUE if you want to force the system to go through with current errors.",
  "RETRY": "Retry",
  "SYNC": "Sync",
  "MANUAL_VALIDATION": "Continue",
  "DASHBOARD_SALES_CHART_CUMUL_TITLE": "Subscriptions Counter",
  "ONLY_BLOCKED": "Only blocked",
  "ONLY_NON_BLOCKED": "Only non blocked",
  "ONLY_ACTIVE": "Only active",
  "ONLY_NON_ACTIVE": "Only non active",
  "GENERIC_TO_OFF_AND_MISSING_BILLING_END": "To off and missing billing end",
  "GENERIC_NEW_SITE_AND_BILLING": "New site end billing",
  "GENERIC_MISSING_SAP_CODE": "Missing SAP Code",
  "GENERIC_MULTIPLE_DEFAULT_PLAYER": "Multiple default player",
  "GENERIC_COMPANIES_MISSING_DATA": "Companies missing data ",
  "GENERIC_NEW_CLIENTS": "Clients missing project",
  "GENERIC_REASON": "Comment",
  "END_BILLING_START_DATE_BLOCKED": "Start date is blocked because this subscription is already invoiced ",
  "END_BILLINGS_START_DATE_BLOCKED": "Start date is blocked because there is at least one subscription already invoiced ",
  "END_BILLINGS_START_DATE_INVOICED_CONFIRMATION": "Are you sure you want to put this End billing date ?  This will create an inconsistency with the invoicing. A credit note may be necessary. An email will be send to the Finance team. ",
  "DATE_PICKER_CHECKBOX_OPTIONS": "Endless end date",
  "KEEP_THE_ACTUAL_LINKED_COMPANY_CHECKBOX_OPTIONS": "Keep the actual linked company",
  "END_BILLING_END_DATE": "End date",
  "GENERIC_FACABO_BELGIQUE": "Facabo Belgique",
  "GENERIC_FACABO_ESPAGNE": "Facabo Spain",
  "GENERIC_FACABO_FRANCE": "Facabo France",
  "GENERIC_FACABO_GERMANY": "Facabo Germany",
  "INVOICES_NUMBER_ADD_SUCCESS": "Invoice add number success",
  "01_MONTH": "January",
  "02_MONTH": "February",
  "03_MONTH": "March",
  "04_MONTH": "April",
  "05_MONTH": "May",
  "06_MONTH": "June",
  "07_MONTH": "July",
  "08_MONTH": "August",
  "09_MONTH": "September",
  "10_MONTH": "October",
  "11_MONTH": "November",
  "12_MONTH": "December",
  "INVOICES_NUMBER_ADD_ERROR": "Invoice add number error",
  "DASHBOARD_ORDERS_LOAD_ERROR": "Orders statistic load error",
  "DASHBOARD_ORDERS_DEPLOY_NUMBER": "Deploy",
  "DASHBOARD_ORDERS_EXCHANGE_NUMBER": "Exchange",
  "DASHBOARD_ORDERS_SUM": "Sum",
  "CLOSE_PLAYER_SUCCESS": "Close player(s) success",
  "SF_INVOICED-STATUS_UPDATE_SUCCESS": "Invoiced via Salesforce update success",
  "CLOSE_PLAYER_ERROR": "Close player(s) error",
  "SF_UPDATE_STATUS_IS_INVOICED_ERROR": "An error has occurred during the update status Salesforce invoiced.",
  "SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU": "The selected subscription(s) should be from the same client.",
  "EXPORT_ANOMALY_TASK_SUCCESS": "The anomaly task is created, you will receive an email with the results",
  "SEND_EMAIL_FINANCE_SUCCESS": "Email is send to finance service",
  "EXPORT_ORDER_TASK_SUCCESS": "The order statistic task is created, you will receive an email with the results",
  "EXPORT_ORDER_TASK_FAIL": "The order statistic task failed",
  "BILLING_SALES_FORCE_FILES": "Sales Force File",
  "DASHBOARD_SALES_TABLEHEADER_CONTENT": "Content Radio/Video",
  "DASHBOARD_SALES_TABLEHEADER_GOAL_CONTENT": "Target content",
  "ORDERS_LIST_ORDER_COUNTER": "The Setup Team cannot guarantee\n" + "the dispatch for this date.\n" + "\n" + "Please select a date after the ",
  "REPORT_PLAYER_MORE_THEN_ONE_ERROR": "A server error occurred while getting report player.",
  "PLAYER_REPORT_OFF_PENDING_DEVICES_ERROR": "A server error occurred while getting report player.",
  "SUBSCRIPTION_BULK_STATUS_UPDATE": "Bulk update",
  "ORDER_NOT_ALLOWED_TEXT_SALESFORCE": "Use SalesForce to update",
  "DESCRIPTION_content.bootFromServer": "Boolean value indicating whether to update the Url Server",
  "DESCRIPTION_content.serverUrl": "Update server url",
  "DESCRIPTION_hardware.audioOut.0.masterSoundLevel": "The main sound level",
  "DESCRIPTION_hardware.videoOut.0.rotation": "Image rotation (in degrees)",
  "DESCRIPTION_net.ethernet.dhcp.enabled": "Boulean value to indicate if the player uses DHCP",
  "DESCRIPTION_net.ethernet.dnsServers": "DNS server address",
  "DESCRIPTION_net.ethernet.enabled": "Network card activation",
  "DESCRIPTION_net.ethernet.gateway": "Player's gateway IP address",
  "DESCRIPTION_net.ethernet.ip": "IP address configured for the player",
  "DESCRIPTION_net.ethernet.netmask": "Player subnet mask",
  "DESCRIPTION_net.wifi.authentication": "Password for wifi",
  "DESCRIPTION_net.wifi.enabled": "Activation of the wifi card",
  "DESCRIPTION_net.wifi.ssid": "Login for WIFI connection",
  "DESCRIPTION_schedule.reboot.time": "Player restart time",
  "DESCRIPTION_time.autoUpdate.protocol": "Time update mode",
  "DESCRIPTION_time.timeZone": "Player timezone",
  "DASHBOARD_SALES_UPDATE_TARGET": "Update targets",
  "DASHBOARD_SALES_EDIT": "Edit content",
  "DASHBOARD_SALES_EXPORT": "Export",
  "DASHBOARD_SALES_LAST_UPDATED": "Last update date:",
  "SALES_DASHBOARD_UPDATE_TARGET_TITLE": "Sales target edit",
  "SALES_DASHBOARD_UPDATE_CONTENT_TITLE": "Sales Content update",
  "SALES_DASHBOARD_EXPORT": "Sales Dashboard Export",
  "SALES_DASHBOARD_UPDATE_YEAR": "Year",
  "SALES_DASHBOARD_UPDATE_SUBSCRIPTION": "Subscription (€)",
  "SALES_DASHBOARD_UPDATE_HARDWARE": "Hardware (€)",
  "SALES_DASHBOARD_UPDATE_CONTENT": "Content  (€)",
  "SALES_DASHBOARD_CONTENT_UPDATE_SUCCESS": "Contents  update success",
  "SALES_DASHBOARD_CONTENT_UPDATE_ERROR": "Contents  update error",
  "SALES_DASHBOARD_CONTENT_LOAD_ERROR": "Contents  load error",
  "SALES_DASHBOARD_TARGET_UPDATE_SUCCESS": "Goals  update success",
  "SALES_DASHBOARD_TARGET_UPDATE_ERROR": "Goals  update error",
  "SALES_DASHBOARD_TARGET_LOAD_ERROR": "Goals   load error",
  "ORDER_LIST_CREATE_SHIPMENT_TITLE": "Create automatic shipment",
  "ORDER_LIST_CREATE_SHIPMENT_NAME": "Last name",
  "ORDER_LIST_CREATE_SHIPMENT_FIRSTNAME": "First name",
  "ORDER_LIST_CREATE_SHIPMENT_COMPANY": "Site",
  "ORDER_LIST_CREATE_SHIPMENT_ADDRESS": "Address",
  "ORDER_LIST_CREATE_SHIPMENT_POSTALCODE": "Zip",
  "ORDER_LIST_CREATE_SHIPMENT_EMAIL": "Email",
  "ORDER_LIST_CREATE_SHIPMENT_PHONE": "Phone",
  "ORDER_LIST_CREATE_SHIPMENT_COUNTRY": "Country",
  "ORDER_LIST_CREATE_SHIPMENT_PROVINCE": "Province",
  "ORDER_LIST_CREATE_SHIPMENT_PROVINCECODE": "Province code",
  "ORDER_LIST_CREATE_SHIPMENT_CITY": "City",
  "ORDER_LIST_CREATE_SHIPMENT_COUNTY": "County",
  "ORDER_LIST_CREATE_SHIPMENT_DESCRIPTION": "Description",
  "ORDER_LIST_CREATE_SHIPMENT_REFERENCE": "Reference",
  "ORDER_LIST_CREATE_SHIPMENT_WEIGHT": "Weight (Kg)",
  "ORDER_LIST_CREATE_SHIPMENT_HEIGHT": "Height (Cm)",
  "ORDER_LIST_CREATE_SHIPMENT_WIDTH": "Width (Cm)",
  "ORDER_LIST_CREATE_SHIPMENT_LENGTH": "Length (Cm)",
  "ORDER_LIST_CREATE_SHIPMENT_DATE": "Shipping date",
  "ORDER_LIST_CREATE_SHIPMENT_IDENTIFIER": "Box type",
  "ORDER_LIST_CREATE_SHIPMENT_TRANSPORTER": "Transporter",
  "ORDER_LIST_CREATE_SHIPMENT_SELECTADDRESS": "Address type",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX2": "Box 2",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX4": "Box 4",
  "ORDER_LIST_SHIPPING_IDENTIFIER_LETTER": "Letter",
  "ORDER_LIST_SHIPPING_IDENTIFIER_TUBE": "Tube",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX_AUDIO": "Box audio",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX_VIDEO": "Box video",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX8_PTL": "Box 8 PTL",
  "ORDER_LIST_SHIPPING_IDENTIFIER_BOX_CD": "CD box",
  "ORDER_LIST_SHIPPING_IDENTIFIER_LISA_COMPACT": "LISA compact",
  "ORDER_LIST_SHIPPING_IDENTIFIER_MMBOX": "MMBOX",
  "ORDER_LIST_SHIPPING_IDENTIFIER_STREAMIT": "Streamit",
  "ORDER_LIST_RATING_SELECT": "Shipping type",
  "ORDER_LIST_INCOTERM_SELECT": "Douane billing",
  "ORDER_LIST_SHIPPING_IDENTIFIER_CUSTOM": "Custom box",
  "braketRental": "Bracket rental",
  "monitorRental": "Monitor rental",
  "onlineMaintenance": "Online and on site maintenance",
  "remoteManagement": "Remote Management",
  "SIMDataService": "SIM Data service",
  "SSLCertificateRenewal": "SSL certificate renewal",
  "widgetService": "Widget service",
  "audioPlayerRental": "Audio player rental",
  "videoPlayerRental": "Video player Rental",
  "4GRouterManagementLicense": "4G Router management license",
  "LANGUAGE_TEXTS_LABEL_LOC": "Label for rental",
  "LANGUAGE_TEXTS_LABEL_LOC_DAY": "Label for day in the past",
  "LANGUAGE_TEXTS_LABEL_LOC_DAY_MON": "Label for month in the past",
  "LANGUAGE_TEXTS_LABEL_RECURRENCE": "Recurrence",
  "LANGUAGE_TEXTS_LABEL_PRODUCT": "Product ( {product} )",
  "LANGUAGE_TEXTS_LABEL_PRODUCT_LOCATION": "Product name ( {product_loc} )",
  "LANGUAGE_TEXTS_LABEL_SERVICE": "Service ( {service} )",
  "LANGUAGE_TEXTS_LABEL_SERVICE2": "Service video ( {service} )",
  "LANGUAGE_TEXTS_LABEL_4G_ROUTER_MANAGEMENT": "4G router management fee",
  "LANGUAGE_TEXTS_LABEL_AUDIO_PLAYER_RENTAL": "Audio player rental fee",
  "LANGUAGE_TEXTS_LABEL_VIDEO_PLAYER_RENTAL": "Video player rental fee",
  "LANGUAGE_TEXTS_LABEL_BRACKET_RENTAL": "Bracket rental fee",
  "LANGUAGE_TEXTS_LABEL_DIV": "Admin fee",
  "LANGUAGE_TEXTS_LABEL_DIV_PERCENT": "Admin fee %",
  "LANGUAGE_TEXTS_LABEL_MATERIAL_LOCATION": "Hardware rental fee",
  "LANGUAGE_TEXTS_LABEL_MAINTENANCE": "Maintenance fee",
  "LANGUAGE_TEXTS_LABEL_VIDEO_MAINTENANCE": "Video Maintenance fee",
  "LANGUAGE_TEXTS_LABEL_MUSIC_SERVICE": "Music service fee",
  "LANGUAGE_TEXTS_LABEL_SOFTWARE_SERVICE": "Software service fee",
  "LANGUAGE_TEXTS_LABEL_MONITOR_RENTAL": "Monitor rental fee",
  "LANGUAGE_TEXTS_LABEL_PROJECT_MANAGEMENT": "Project management fee",
  "LANGUAGE_TEXTS_LABEL_ONLINE_MAINTENANCE": "Online maintenance fee",
  "LANGUAGE_TEXTS_LABEL_AUDIO_SETUP": "Audio setup fee",
  "LANGUAGE_TEXTS_LABEL_SETUP": "Setup fee",
  "LANGUAGE_TEXTS_LABEL_VIDEO_SETUP": "Video setup fee",
  "LANGUAGE_TEXTS_LABEL_AUDIO_PRODUCTION": "Audio communication fee",
  "LANGUAGE_TEXTS_LABEL_PRODUCTION": "Communication fee",
  "LANGUAGE_TEXTS_LABEL_VIDEO_PRODUCTION": "Video communication fee",
  "LANGUAGE_TEXTS_LABEL_REMOTE_MANAGEMENT": "Remote management fee",
  "LANGUAGE_TEXTS_LABEL_SERVICE_SIM_DATA": "SIM data service fee",
  "LANGUAGE_TEXTS_LABEL_SLL_CERTIFICATE_RENEW": "SSL certificate renewal fee",
  "LANGUAGE_TEXTS_LABEL_WIDGET": "Widget service Fee",
  "LOAD_CONCEPT_SUCCESS": "Load Concepts success",
  "LOAD_CONCEPT_ERROR": "Load Concepts error",
  "INVOICES_PREVIEW_HELP_1": "The system will generate a preview of the invoice (do NOT send this to a customer).",
  "INVOICES_PREVIEW_HELP_2": "Please select a recurrence and Billing date that align with the existing contracts.",
  "INVOICES_PREVIEW_HELP_3": "If your contract includes shift days, you must select the first day of the next month.",
  "INVOICES_PREVIEW_ALREADY_INVOICES": "This invoices are already invoiced.",
  "INVOICES_MANAGEMENT_HELP_1": "The system will erase the invoice history and treat the new link as if it has never been invoiced. This ensures that the subscription is included in the periodic adjustment, even if it is not an entirely new deployment.",
  "INVOICES_MANAGEMENT_HELP_2": "If the linked company is marked as \"never invoiced,\" the system will update its status to \"invoiced\" to enable the use of periodic adjustments instead of the classical adjustment.",
  "SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_NAME": "New site name",
  "SITE_LIST_MERGE_SUBSCRIPTION_SITE_NEW_EXTERNAL_ID": "New site externalID",


}
